import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'danger-delete-form',
  templateUrl: './danger-delete-form.component.html',
  styleUrls: ['./danger-delete-form.component.scss'],
})
export class DangerDeleteForm {
  @Input() width: string | undefined;
  @Input() outerWidth: string | undefined;
  @Input() load: Loadable<any> | Loadable<any>[];
  @Input() loading: boolean;
  @Input() erred: boolean;
  @Input() title: string;
  @Input() submit: () => Promise<void>;
  @Input() submitting: boolean;
  @Input() submitText: string;
  @Output() close = new EventEmitter();
  @Output() submitted = new EventEmitter();

  @Input() requiredPhrase: string = 'delete me';
  phrase: string = '';
}
